module.exports = __webpack_public_path__ + "static/media/dawghawtdawg-macbook-high-scores.2c8fe844.jpg";